import { render, staticRenderFns } from "./ShowBookGroupAdd.vue?vue&type=template&id=818539a6"
import script from "./ShowBookGroupAdd.vue?vue&type=script&lang=js"
export * from "./ShowBookGroupAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports